<template>
  <div class="happy_video">
    <div class="video_wrap">
      <video-player
        @titleClick="titleClick"
        :title="infoObj.title"
        :options="options"
        :videoInfo="video"
        @onPlayerPlay="handleplay"
        @onPlayerEnded="handlePlayEnd"
        @onPlayerTimeupdate="handlePlayerTimeupdate"
        @onPlayerLoadeddata="loadDate"
        ref="videoPlayer"
      ></video-player>
      <div class="cover">
      </div>
    </div>
    <modal
      ref="pop"
      btnType="2"
      sureText="确认"
      cancelText="取消"
      @cancel="cancelFn"
      :goActiveFlag="true"
      @submit="sure"
      class="happy_video_modal"
    >
      <template v-slot:body>
        <p>后面的内容更精彩哦，你确定要退出吗</p>
      </template>
    </modal>
    <modal
      ref="popOver"
      :btnType="btnNum"
      :sureText="sureTitle"
      cancelText="知道了"
      @cancel="cancelFn"
      :goActiveFlag="true"
      :ifHasVideo="ifHasVideo"
      @submit="sureOver"
      class="happy_video_modal"
    >
      <template v-slot:body>
        <p>很棒哦，继续努力，你会做的更好</p>
      </template>
    </modal>
  </div>
</template>
<script>
import VideoPlayer from '../../components/video-space/index.vue';
import Modal from '../../components/common/modal.vue';
import { _nextVideo } from '../../api/parent-course';
import { verticalScreen } from '../../assets/js/vertical-screen';

export default {
  name: 'happy-space-video',
  components: {
    VideoPlayer,
    Modal,
  },
  props: {},
  data() {
    return {
      video: {}, // 单种视频详情
      videoId: '',//视频id
      columnId: '',//栏目id
      ifHasVideo: true,//是否有下一条视频
      from: '',//视频来源
      btnNum: '2',
      sureTitle: '下一个',
    };
  },
  watch: {},
  computed: {
    options() {
      return {
        sources: [
          {
            type: 'video/mp4',
            autoplay: false,
            // src:'http://172.16.70.46:8300/video/sport/man/01.m4v',
            // src:'http://172.16.12.229:9100/psy-bucket/1427874319594680321.mp4'
            // src: 'http://172.16.12.229:9100/' + JSON.parse(this.infoObj.materialIdList)[0].url
            // src: 'http://172.16.12.104:8999/' + JSON.parse(this.infoObj.materialIdList)[0].url

            src: JSON.parse(this.infoObj.materialIdList)[0].url,
            // src: 'http://' + location.host + '/' + JSON.parse(this.infoObj.materialIdList)[0].url
          }],
        // poster: 'https://avatars.githubusercontent.com/u/499550?v=4',
      };
    },
    infoObjTag() {
      return this.infoObj && this.infoObj.tags.split(',').slice(0, 3);
    },
  },
  methods: {
    //横屏
    resize() {
      let width = window.innerWidth,
        height = window.innerHeight,
        $wrapper = document.getElementById('app'),
        style = '';
      style += 'width:' + width + 'px;'; // 注意旋转后的宽高切换
      style += 'height:' + height + 'px;';
      // style +="-webkit-transform: rotate(0); transform: rotate(0);";
      // style +="-webkit-transform-origin: " + width / 2 +"px " + width / 2 +"px;";
      // style +="transform-origin: " + width / 2 +"px " + width / 2 +"px;";
      $wrapper.style.cssText = style;
    },
    //返回
    titleClick() {
      this.$refs.pop.openDialog();
    },
    sure() {
      this.$router.back();
      this.$refs.pop.closeDialog();
    },
    //取消
    cancelFn() {
      this.$refs.pop.closeDialog();
      this.$refs.popOver.closeDialog();
    },
    //点击下一条
    sureOver() {
      this.from = 2;
      this.nextVideo();
      if (!this.ifHasVideo) {
        this.$refs.popOver.closeDialog();
      }
    },

    handleplay(e) {
      //   this.startTime = dayjs().format('HH:mm:ss');
      // 默认竖屏
      this.$refs.videoPlayer.setFullScreen(true);
    },
    // 播放完毕
    handlePlayEnd(fullScreen) {
      // this.fullScreen = fullScreen;
      // 如果是正常情况下播放完毕，弹框获取金币
      this.showModal = true;
      this.$refs.popOver.openDialog();
    },
    handlePlayerTimeupdate(player) {
      // 获取播放时长
      this.playTime = player.currentTime();
    },
    loadDate() {
    },
    //下一条视频
    nextVideo() {
      _nextVideo({
        columnId: this.columnId,
        nowContentId: this.videoId,
      }).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.btnNum = '2';
            this.ifHasVideo = true;
            if (this.from == 2) {
              this.$storage.setStore('happySpaceVideo', res.data);
              this.$refs.pop.closeDialog();
              this.$refs.popOver.closeDialog();
              this.videoId = res.data.id;
              this.$router.replace({
                path: '/loadingPage',
                query: {
                  videoFlag: 1,
                },
              });
            }
          } else {
            this.btnNum = '1';
            this.sureTitle = '知道了';
            this.ifHasVideo = false;
          }
        } else {
          this.btnNum = '1';
          this.sureTitle = '知道了';
          this.ifHasVideo = false;
        }
      });
    },
  },
  beforeCreate() {},
  created() {
    // 获取video对用的信息
    this.infoObj = this.$storage.getStore('happySpaceVideo');
    this.videoId = this.infoObj.id;
    this.columnId = this.$storage.getStore('happyInfoTab').id;
  },
  beforeMount() {},
  mounted() {
    verticalScreen();
    this.resize();
    // this.$refs.videoPlayer.setFullScreen(true);
    this.from = this.$route.query.from;
    this.nextVideo();
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.video_wrap {
  position: relative;

  .cover {
    margin-top: 50%;
    margin-left: -47%;
    position: fixed;
    z-index: 20003;
    width: 110vh;
    height: 120px;
    left: 0;
    top: 40px;
    right: 0;
    bottom: 0;
    -webkit-transform: rotate(90deg) translate3d(calc(50vh - 50vw), calc(50vh - 50vw), 0);
    transform: rotate(90deg) translate3d(calc(50vh - 50vw), calc(50vh - 50vw), 0);
    background: red;
    opacity: 0;
  }
}
</style>
